import { atom } from 'jotai';

export const cycleInformationOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const cycleInformationNextBlockedAtom = atom<boolean>(false);
export const evaluationElementsOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const feedback360SettingsOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const deadlinesOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const communicationsOnNextAtom = atom<(() => Promise<boolean>) | null>(null);

export interface EvaluationElementsLiveSelection {
    cycleEvaluationGroupId: string;
    includesFeedback360: boolean;
    isFeedback360TemplateMissing: boolean;
}

export const evaluationElementsLiveSelectionAtom = atom<EvaluationElementsLiveSelection | null>(
    null,
);

export const defineAudienceOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const selectEvaluatorsOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const selectTemplateOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const questionnaireCreationOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const scheduleCreationOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const lastSavedAtAtom = atom<Date | null>(null);
